import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

// ✅ En çok görüntülenen ürünler
export const getTopViewedProducts = async (days = 30, limit = 10) => {
  try {
    const getTopProducts = httpsCallable(functions, 'getTopViewedProducts');
    const result = await getTopProducts({ days, limit });
    return result.data;
  } catch (error) {
    console.error('❌ getTopViewedProducts hatası:', error);
    return { success: false, error: error.message };
  }
};

// ✅ Kategori bazlı görüntülemeler
export const getProductCategoryViews = async (days = 30) => {
  try {
    const getCategoryViews = httpsCallable(functions, 'getProductCategoryViews');
    const result = await getCategoryViews({ days });
    return result.data;
  } catch (error) {
    console.error('❌ getProductCategoryViews hatası:', error);
    return { success: false, error: error.message };
  }
};